import * as types from 'store/actions/types';
import services from 'services/services';
import { getCurrentDomainId } from './getCurrentDomainId';

export const setDomainIdByHostname = () => async (dispatch) => {
	try {
		const url = `/domains/list`;
		const domains = await services.get(url);
		const domainId = await getCurrentDomainId(domains.data);

		if (domainId != null) {
			dispatch({
				type: types.SET_DOMAIN_DATA,
				payload: domainId
			});
		}

		dispatch({
			type: types.SET_DOMAIN_LOADING
		});

		return domainId;
	} catch {
		dispatch({
			type: types.SET_DOMAIN_ERROR
		});
		return null;
	}
};
